import { render, staticRenderFns } from "./LoggersCFM.vue?vue&type=template&id=28f20268&"
import script from "./LoggersCFM.vue?vue&type=script&lang=js&"
export * from "./LoggersCFM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports